import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { each } from 'lodash';

import UserSearch from 'mewe/stores/models/user-search-model';
import JSONSerializer from 'mewe/utils/store-utils/serializers/json-serializer';

export default class MwSmartSearchUser extends Component {
  element;

  @service chat;
  @service router;
  @service account;
  @service dynamicPopups;

  @tracked user;

  constructor() {
    super(...arguments);
    this.setInitialParams();
  }

  setInitialParams() {
    const serializer = JSONSerializer.create();
    const user = this.args.userData;

    each(['description', 'currentCity'], (element) => {
      if (typeof user[element] !== 'undefined' && user[element].length !== 0) {
        user[element] = user[element].replace(/\r?\n|\r/g, ' ');
      }
    });

    this.user = serializer.deserializeOne(UserSearch, user);
  }

  @action
  goToProfile() {
    this.router.transitionTo('app.publicid.posts', this.user.profileId);
    this.args.closeSmartSearch();
  }

  @action
  chatWith() {
    this.chat.openThreadByParticipants([this.user]);
    this.args.closeSmartSearch();
  }
}
